module.exports = __webpack_public_path__ + "img/icon-small.a62dc0b0.svg";